import { Box, Typography } from '@mui/material'
import React from 'react'
import Subscribe from './Subscribe'
import i18next from 'i18next'

const Newsletters = () => {
    let lng = i18next.language
    return (
        <>
            <Box sx={{ position: 'relative', zIndex: 2 }}>
                <Typography variant='h6' color={'primary.main'} >{lng === 'ar' ? 'تواصل معنا' : 'Contact Us'}</Typography>
                <Typography color={'primary.text'} >
                    {lng === 'ar' ? 'أرسل بريدك الإلكتروني لأي استفسار وسنقوم بالرد عليك في أقرب وقت' :
                        'Send us your email for any inquiries and we will respond to you as soon as possible.'}
                </Typography>
                <Subscribe />
            </Box>
        </>
    )
}

export default Newsletters